import React from 'react';

function Pagination({
    currentPage,
    lastPage,
    onPageChange,
    maxVisiblePages = 3
}) {
    const getPageNumbers = () => {
        const pages = [];

        if (lastPage <= maxVisiblePages + 2) {
            for (let i = 1; i <= lastPage; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);

            if (currentPage > 3) {
                pages.push('...');
            }

            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(lastPage - 1, currentPage + 1);

            if (currentPage <= 3) {
                endPage = maxVisiblePages;
            }

            if (currentPage >= lastPage - 2) {
                startPage = lastPage - maxVisiblePages + 1;
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (currentPage < lastPage - 2) {
                pages.push('...');
            }

            if (lastPage > 1) {
                pages.push(lastPage);
            }
        }

        return pages;
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= lastPage && page !== currentPage) {
            onPageChange(page);
        }
    };

    if (lastPage <= 1) {
        return null;
    }

    return (
        <div className="d-flex justify-content-end mt-3">
            <nav>
                <ul className="pagination pagination-sm mb-0">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link pgn-clr"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{ zIndex: 0 }}
                        >
                            <i class="bi bi-arrow-left-circle-fill"></i>
                        </button>
                    </li>

                    {getPageNumbers().map((page, index) => (
                        page === '...' ? (
                            <li key={`ellipsis-${index}`} className="page-item disabled">
                                <span className="page-link pgn-clr" style={{ zIndex: 0 }}>...</span>
                            </li>
                        ) : (
                            <li
                                key={page}
                                className={`page-item pgn-clr ${currentPage === page ? 'active' : ''}`}
                            >
                                <button
                                    className="page-link pgn-clr"
                                    onClick={() => handlePageChange(page)}
                                    style={{ zIndex: 0 }}
                                >
                                    {page}
                                </button>
                            </li>
                        )
                    ))}

                    <li className={`page-item ${currentPage === lastPage ? 'disabled' : ''}`}>
                        <button
                            className="page-link pgn-clr"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === lastPage}
                            style={{ zIndex: 0 }}
                        >
                            <i class="bi bi-arrow-right-circle-fill"></i>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default Pagination;